import { Game } from 'types'
import audioGame3 from 'assets/sounds/a-noite-no-castelo.mp3'
import audioGame6 from 'assets/sounds/composicao-com-gravuras.mp3'

export const gameListEn: Game[] = [
  {
    id: '1',
    gameTitle: 'Game 1',
    content: [
      {
        text: 'Question and Answer with open strings in pizzicato',
        style: ['title1'],
      },
      {
        text: 'Author: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          "Provide awareness to the students of their individuality and their role within the collective, to establish the idea of musical narrative, questions and answers, emphasizing the use of the violoncello's four strings, the pizzicato, and the different rhythms, metrics, timbres and dynamics.",
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text:
          'Explain to the students what could be a question and what could be an answer in a musical narrative.',
        style: ['itemList'],
      },
      {
        text:
          'Give them an example using only the open strings of the cello embracing the many different rthythms, metrics, dynamics and variations in character.',
        style: ['itemList'],
      },
      {
        text:
          'Propound a question to the first student, who must play an answer. Subsequently, do the same for the second student, and consecutively, approaching all the students one by one, individually.',
        style: ['itemList'],
      },
      {
        text: 'Perform a few rounds of the game.',
        style: ['itemList'],
      },
      {
        text: 'Organize the students in pairs, arranged in different spots of the classroom.',
        style: ['itemList'],
      },
      {
        text:
          'One student from each duo should ask the questions and the other student should do the answers for a few minutes.',
        style: ['itemList'],
      },
      {
        text: 'Alternate the roles of the previous activity.',
        style: ['itemList'],
      },
      {
        text: 'Re-organise the class into a semicircle.',
        style: ['itemList'],
      },
      {
        text:
          'Each pair comes to the center of the semicircle and performs some series of questions and answers, presenting them to their classmates.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'Provide students with autonomy in deciding the number of questions and answers they present to their classmates, the distribution of roles and the combinations between them that determine the beginning and end of the presentation to colleagues.',
        style: ['itemList'],
      },
      {
        text:
          "It is often observed an increase in complexity in the elaboration of students' questions and answers throughout the activities.",
        style: ['itemList'],
      },
    ],
  },
  {
    id: '2',
    gameTitle: 'Game 2',
    content: [
      {
        text: 'Green Light X Red Light',
        style: ['title1'],
      },
      {
        text: 'Author: Maria Teresa Alencar de Brito',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Work on the differences between sound and silence, as well as its importance and role within the musical construction; deepen the importance of collectivity within the musical process; to establish the idea of musical dialogue.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      { text: 'To arrange the students in a semicircle.', style: ['itemList'] },
      {
        text:
          'Propose that students explore different sonorities on cello, associated with the extended techniques.',
        style: ['itemList'],
      },
      {
        text: 'Present a certain sonority and propose that students, together, reproduce it.',
        style: ['itemList'],
      },
      {
        text: 'Stimulate students to explore, individually, their instruments, seeking new sounds.',
        style: ['itemList'],
      },
      {
        text:
          'Each student must present a researched sound to the other class members, who must, together, reproduce it.',
        style: ['itemList'],
      },
      {
        text:
          'Show two small posters to the students, in the colors green and red. Relate the cards with the traffic laws, where green means "play" and red means "do not play".',
        style: ['itemList'],
      },
      {
        text:
          'Execute some combinations with the posters, proposing that the students play any sounds they want, deriving from the traditional techniques or from the extended techniques.',
        style: ['itemList'],
      },
      {
        text:
          'Propose some dynamic variation depending on how the posters are presented to the students.',
        style: ['itemList'],
      },
      {
        text:
          'Choose a student to be the "conductor" of the others, with the role of presenting the posters to classmates.',
        style: ['itemList'],
      },
      {
        text:
          'Divide the class into two groups, choosing one "conductor" per group, with each "conductor" receiving a set of green and red posters.',
        style: ['itemList'],
      },
      {
        text:
          'Each group should follow the instructions of their respective "conductors", who should communicate in a non-verbal manner in order to provide interaction and musical dialogue between the two groups.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text: `We must be attentive and stimulate the students' listening capacity, emphasizing that the different combinations of sounds and silences established between the "conductors" provide the creation of a musical narrative.`,
        style: ['itemList'],
      },
    ],
  },
  {
    id: '3',
    gameTitle: 'Game 3',
    content: [
      {
        text: 'Night at the Castle',
        style: ['title1'],
      },
      {
        text: 'Author: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Establish a relationship between the imagined and the sound; reinforce the trust between the pairs; develop the power of choice within the musical creation.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text:
          'Tell the students a story about a traveler who arrives at a haunted castle in the middle of a stormy night.',
        style: ['itemList'],
      },
      {
        text:
          'Inventory sounds that could compose this scenery: thunder, gusts of wind, sound of rain, bats, ghosts, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Place students in different spots in the room, with a certain distance between them.',
        style: ['itemList'],
      },
      {
        text:
          'To assign the role of traveller to one of the students. This student will take a walk around the castle avoiding to touch the "objects" guided by their hearing. When the traveler approaches an object in the castle, the student who represents that object will perform its specific sound. As the traveler moves away from the object, the sound decreases in intensity, and the student who is now closer to the traveler will begin to play the sound corresponding to his object, and successively, composing a musical narrative.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'In order to encourage students to intensify their listening ability, we can propose that the traveler stays longer in front of the object they want to hear, or return to a particular object they want to hear again, playing an active role in the composition of the narrative.',
        style: ['itemList'],
      },
      {
        style: ['audio'],
        audio: audioGame3,
      },
    ],
  },
  {
    id: '4',
    gameTitle: 'Game 4',
    content: [
      {
        text: 'Musical Signature',
        style: ['title1'],
      },
      {
        text: 'Author: Wanderson Cruz',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Enable the experience of creation from pre-established musical cells; expose the differences between the polyphonies and homophonies; encourage the power of choice within musical creation.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text:
          'Ask students what a signature is and relate the answers to what could be a musical signature.',
        style: ['itemList'],
      },
      {
        text: 'Give an example using sounds from traditional and extended techniques.',
        style: ['itemList'],
      },
      {
        text:
          'Propose that individual students create their musical signatures, using the sounds they want, and present them to the other classmates.',
        style: ['itemList'],
      },
      {
        text:
          'Ask them to perform their signatures more than once, so we can assure they remain the same in both executions.',
        style: ['itemList'],
      },
      {
        text:
          'Choose one of the students to be the "conductor", who should compose a song using only the musical signatures created by the other students.',
        style: ['itemList'],
      },
      {
        text:
          'The "conductor" should create signs that indicate when a student should start playing his signature, when to stop, with what intensity, speed and other variables, how many students should play simultaneously, creating dialogues, interaction and different combinations between the signatures.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'We should encourage the students to work on their listening and their artistic choice in front of the material presented by their classmates. Thus, we again prevent the game from becoming mechanical and provide for the construction of a consistent musical idea.',
        style: ['itemList'],
      },
      {
        text:
          'It is advisable to the teacher be the conductor in all games played for the first time, however, different students should be assigned for this role next, so everyone can take turns as conductors at all improvisation games.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '5',
    gameTitle: 'Game 5',
    content: [
      {
        text: 'Same X Similar X Different',
        style: ['title1'],
      },
      {
        text: 'Author: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Work on ideas of similarity and difference in music; facilitate the creation from a element previously given; work the idea of phrases or musical narratives.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text:
          'Present three small posters. One of the posters should display the mathematical sign of equals, the second should display the sign of not equal, and on another the sign of approximately equal to sign.',
        style: ['itemList'],
      },
      {
        text:
          'The first student must freely create a musical phrase, using any sounds they desire.',
        style: ['itemList'],
      },
      {
        text:
          'The teacher chooses one of the posters and shows the second student that he or she  should follow the instructions on the poster, thus performing a phrase that is the same, similar or different from the sentence created by the first student.',
        style: ['itemList'],
      },
      {
        text:
          'Give one of the posters to the third student, who should perform their phrase following the instructions making reference to the phrase executed by the second student, and so forth until everyone played some rounds in the game.',
        style: ['itemList'],
      },
      {
        text:
          'Choose one student to be the "conductor" and show the posters to the others. We can increase complexity in this round of the game, proposing that the "conductor", besides choosing the posters, also choose which student will perform the new phrase, and for this, the "conductor" must use non-verbal signs of language.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'When increasing the complexity in the game variation we provide them to develop more attention to their hearing.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '6',
    gameTitle: 'Game 6',
    content: [
      {
        text: 'Composition with images and novel notations',
        style: ['title1'],
      },
      {
        text: 'Author: Various authors/Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Bringing students closer to the idea of composition; developing their own symbology that represents their musical ideas; making contact with different ways of writing and musical representation; paying attention to the existing limitations in any type of musical writing; bringing together composers and performers.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text:
          'Previously ask to the students to bring engravings, images, or pictures to make a collective creation.',
        style: ['itemList'],
      },
      {
        text: 'Split the class into groups of five or six students.',
        style: ['itemList'],
      },
      {
        text:
          'Each group should examine the pictures and images and create a story, which may result from how many images the group chooses for this, and this number may vary between the different groups.',
        style: ['itemList'],
      },
      {
        text: 'Ask them to present the storyline, with a beginning, middle and ending.',
        style: ['itemList'],
      },
      {
        text:
          'Propose that students choose different sounds and their combinations so that the story they create can be represented through music alone.',
        style: ['itemList'],
      },
      {
        text:
          'After creating the song, distribute to each group a cardboard, a box of colored pencils and some other materials, such as colored ribbons, toothpicks, pebbles, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Each group should "write" their song using the signs they want, drawings, words, symbols, etc.',
        style: ['itemList'],
      },
      {
        text:
          'After writing the song, each group should rehearse its composition a few times, using or not the support of the score.',
        style: ['itemList'],
      },
      {
        text: 'Ask each group to perform their songs to the others.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'During the process of creating the story and music we must give students autonomy so that they organize themselves and establish relationships among themselves, stimulating that all students should participate in this process.',
        style: ['itemList'],
      },
      {
        text:
          'In the same way we should give autonomy to the students during their rehearsals and during the presentation, as groups can choose how they will do this presentation, telling or not the story created, presenting or not the score.',
        style: ['itemList'],
      },
      {
        text:
          'We should only stimulate that during the presentation of the music the communication between the students is established in a non-verbal way.',
        style: ['itemList'],
      },
      {
        audio: audioGame6,
        style: ['audio'],
      },
    ],
  },
  {
    id: '7',
    gameTitle: 'Game 7',
    content: [
      {
        text: 'Improvisation with ostinato',
        style: ['title1'],
      },
      {
        text: 'Author: Various authors/Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Work on the notions of solo and tutti; work on the idea of ostinato; and work the concept of musical form.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text: 'Explain to students what an ostinato is.',
        style: ['itemList'],
      },
      {
        text:
          'Propose a simple rhythmic ostinato, to be performed, for example, with open strings.',
        style: ['itemList'],
      },
      {
        text: 'Divide the group into orchestra and soloist.',
        style: ['itemList'],
      },
      {
        text:
          'The group representing the orchestra should perform the ostinato, while the soloist student performs different phrases or musical ideas, using the sounds they want.',
        style: ['itemList'],
      },
      {
        text:
          'Set with the students what the indication will be that will determine the end of the solo.',
        style: ['itemList'],
      },
      {
        text:
          'After one student has performed the solo, the next student becomes the soloist, successively until all students have participated in the role of soloists.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'During the solos it is not necessary that we think in harmony or vocal conduction, as for the improvisation does not need to obey the patterns of tonalism.',
        style: ['itemList'],
      },
      {
        text:
          'The intention of this improvisation is that the students can freely organize their ideas, using the contents already absorbed by them.',
        style: ['itemList'],
      },
      {
        text:
          'Improvisation can be organized in different ways, for example, by establishing that after the end of each solo a certain number of times the ostinato will be performed, or by proposing a rondo form, where part A will be a fixed number of times that the orchestra will perform the ostinato, or a theme created jointly by the students.',
        style: ['itemList'],
      },
      {
        text:
          'We can organize and add complexities throughout the rounds, interspersed with collective auditions of the improvisations created by the students.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '8',
    gameTitle: 'Game 8',
    content: [
      {
        text: 'Enchanted Forest',
        style: ['title1'],
      },
      {
        text: 'Author: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text: 'Work the musical dialogue; work the idea of polyphony.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text:
          'This game is a variation of game 3, Night at the Castle, however, some complexities were added.',
        style: ['itemList'],
      },
      {
        text: 'Place students in different spots in the room, with some distance between them.',
        style: ['itemList'],
      },
      {
        text: 'Tell a story about two explorers who arrive in an enchanted forest.',
        style: ['itemList'],
      },
      {
        text: 'Each tree will emit a sound chosen by the students to represent it.',
        style: ['itemList'],
      },
      {
        text: 'The explorers may have their eyes open or blindfolded.',
        style: ['itemList'],
      },
      {
        text:
          'As they approach the trees, they emit the sound chosen by the students to represent it. As they move away, the intensity of the sound decreases and the student who is closest to it begins to emit their chosen sound.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          'We should add some differences and complexities in this game in comparison to game 3, Night at the Castle.',
        style: ['itemList'],
      },
      {
        text:
          'One of the complexities to be added is the participation of two "conductors”, which will result in musical interactions and dialogues between them.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '9',
    gameTitle: 'Game 9',
    content: [
      {
        text: 'Zoo Tour',
        style: ['title1'],
      },
      {
        text: 'Author: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Work on different musical options of the same sonority, work on the idea of musical narrative.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text:
          'Tell students a story of a visitor who arrives at a zoo and observes the different animals.',
        style: ['itemList'],
      },
      {
        text:
          'Each student chooses an animal to be represented by, choosing sounds that characterizes it.',
        style: ['itemList'],
      },
      {
        text:
          'The visitor takes a walk through the zoo, positioning himself in front of the different animals, and at that moment, the animals reproduce the sound chosen by the students.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          "We can propose that the animals emit their sounds according to the visitor's body indications, performing different levels of dynamics, intensity and musical character.",
        style: ['itemList'],
      },
      {
        text:
          "As in previous games, we can record improvisations, making it possible that the next rounds of games, the interactions are increasingly coming from students' musical choices.",
        style: ['itemList'],
      },
    ],
  },
  {
    id: '10',
    gameTitle: 'Game 10',
    content: [
      {
        text: 'The birds and the hunter',
        style: ['title1'],
      },
      {
        text: 'Author: Cláudia Freixedas/Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objectives:',
        style: ['title2'],
      },
      {
        text:
          'Work on the freedom and the different options for the beginning, the development and the end of the musical "play", to work on issues related to ecology and acoustic ecology; to work on the dialogues, the polyphonies and the notion of musical form.',
        style: ['paragraph'],
      },
      {
        text: 'Methodology:',
        style: ['title2'],
      },
      {
        text: 'To arrange the students in a semicircle.',
        style: ['itemList'],
      },
      {
        text: 'Ask the students what bird sounds they know.',
        style: ['itemList'],
      },
      {
        text: 'Inventory with the students some of these sounds.',
        style: ['itemList'],
      },
      {
        text:
          'Propose that students create on their cellos sounds that represent those previously made inventory of.',
        style: ['itemList'],
      },
      {
        text: 'Create along with the students a sound that represents the hunter.',
        style: ['itemList'],
      },
      {
        text:
          'Each student will act representing the sound of one of the birds, and one student will represent the hunter.',
        style: ['itemList'],
      },
      {
        text: 'The birds must dialogue among themselves, creating a musical context.',
        style: ['itemList'],
      },
      {
        text:
          'The student who represents the hunter can intervene in the woods at will. When the hunter intervenes, all the birds become quiet.',
        style: ['itemList'],
      },
      {
        text: 'Gradually, the birds start singing and talking to each other again.',
        style: ['itemList'],
      },
      {
        text: 'The hunter can intervene in the forest as many times as he or she wishes.',
        style: ['itemList'],
      },
      {
        text: 'Note:',
        style: ['title2'],
      },
      {
        text:
          "We should provide autonomy to the students, leaving to their discretion when it will be the beginning and the end of the improvisation, as well as, how long after the hunter's intervention, the birds will sing again.",
        style: ['itemList'],
      },
    ],
  },
]
